import {
  LOADER_SPIN_DURATION,
  LOGO_LOOP_PATH,
  LOGO_LOOP_VIEWBOX,
} from "@ergon-ai/utils/logo-loop";

import "./logo-loop.css";

import { cn } from "@ergon-ai/ui";
import { ICON_SIZE } from "@ergon-ai/ui/icons";

export interface SpinnerProps {
  size?: number;
  label?: string;
  className?: string;
}

function Spinner({ size = ICON_SIZE.md, label, className }: SpinnerProps) {
  const glyph = (
    <svg
      width={size}
      height={size}
      viewBox={LOGO_LOOP_VIEWBOX}
      aria-hidden="true"
      focusable="false"
      className={cn("ergo-logo-loop shrink-0", className)}
      style={{ animationDuration: `${LOADER_SPIN_DURATION}ms` }}
    >
      <path d={LOGO_LOOP_PATH} fill="currentColor" />
    </svg>
  );
  if (label === undefined) return glyph;
  return (
    <span role="status" data-slot="spinner" className="inline-flex">
      {glyph}
      <span className="sr-only">{label}</span>
    </span>
  );
}

export const LOADER_STYLES = {
  variant: { default: "text-action-primary", white: "text-action-primary-ink" },
} as const;

export interface LoaderProps {
  label?: string;
  size?: number;
  variant?: keyof typeof LOADER_STYLES.variant;
  fill?: boolean;
  className?: string;
}

function Loader({
  label,
  size = 48,
  variant = "default",
  fill = false,
  className,
}: LoaderProps) {
  return (
    <div
      data-slot="loader"
      className={cn(
        "flex items-center justify-center",
        fill && "flex-1 self-stretch",
        className,
      )}
    >
      <Spinner
        size={size}
        label={label}
        className={LOADER_STYLES.variant[variant]}
      />
    </div>
  );
}

export { Loader, Spinner };
